/* Video player context value. Split from provider to satisfy ESLint react-refresh. */

import { createContext } from "react";
import type { VideoTrack, VideoPlayerState } from "@/types/videoPlayer";

export interface VideoPlayerContextValue {
  state: VideoPlayerState;
  open: (track: VideoTrack) => void;
  close: () => void;
}

export const VideoPlayerContext = createContext<VideoPlayerContextValue | null>(null);
